<template>
  <div class="footer-container">
    <div class="china-text">中国证券报有限责任公司版权所有，未经书面授权不得复制或建立镜像。</div>
    <div class="english-text">
      Copyright 2001-2023 China Securities Journal. All Rights Reserved. 互联网新闻信息服务许可证：10120200010 |
      网络出版服务许可证：（署）网出证（京）字第302号 | 广播电视节目制作经营许可证：（京）字第20882号 京ICP备12041706号-1 |
      经营许可证编号：京B2-20180749 | 京公网安备110102000060-1 | 不良信息举报：010-63070559 zzbwlb@vip.163.com
    </div>
  </div>
</template>

<script>
export default {
  name: "comFooter",
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
